// extracted by mini-css-extract-plugin
module.exports = {"faq":"DlpFAQ_faq__qWyWY"};